import { CSRF_TOKEN } from "@pages/csrf";
import { Product } from "./types";

const getProducts = (aoFlowCategory?: "online" | "staff_led") => {
  const url = new URL("/v1/accountopeningcoreproduct/", window.location.origin);
  if (aoFlowCategory) {
    url.searchParams.set("ao_flow_category", aoFlowCategory);
  }
  return fetch(url.toString(), {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
  });
};

const addNewProduct = (payload: Product) => {
  return fetch("/v1/accountopeningcoreproduct/", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
    body: JSON.stringify(payload),
  });
};

const editProduct = (product: Product, changeLog: string) => {
  const payload = { ...product, changelog: changeLog };
  return fetch(`/v1/accountopeningcoreproduct/${product.uuid}/`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
    body: JSON.stringify(payload),
  });
};

const auditLogs = (aoFlowCategory?: "online" | "staff_led") => {
  const url = new URL("/v1/accountopeningcoreproduct/audit_logs/", window.location.origin);
  if (aoFlowCategory) {
    url.searchParams.set("ao_flow_category", aoFlowCategory);
  }
  return fetch(url.toString(), {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
  });
};

// Backwards compatibility aliases
const staffLedAuditLogs = () => auditLogs("staff_led");
const onlineAuditLogs = () => auditLogs("online");

const getBundles = () => {
  return fetch("/v1/bundles/", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
  });
};

const bundleAuditLogs = () => {
  return fetch("/v1/bundles/audit_logs/", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
  });
};

const importProductsFromFile = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetch("/v1/accountopeningcoreproduct/import_from_file/", {
    method: "POST",
    headers: {
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
    body: formData,
  });
};

const deleteProductApi = (payload: Product) => {
  return fetch(`/v1/accountopeningcoreproduct/${payload.uuid}/`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": CSRF_TOKEN,
    },
    credentials: "same-origin",
  });
};

export {
  getProducts,
  getBundles,
  addNewProduct,
  editProduct,
  deleteProductApi,
  importProductsFromFile,
  auditLogs,
  staffLedAuditLogs,
  onlineAuditLogs,
  bundleAuditLogs,
};
